export default "__VITE_ASSET__hS6H183j__"